import React from 'react';
import './Header.css';
import Countdown from 'react-countdown';
import { Link } from 'gatsby';
import {
    BLACK_FRIDAY_COUNTDOWN_END_DATE,
    BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE,
    CYBER_WEEK_COUNTDOWN_END_DATE,
} from '../../utils';

// Timer display component - formats and displays countdown values
const Timer = ({ days, hours, minutes, seconds }) => {
    const numberFormatter = new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });
    days = numberFormatter.format(days);
    hours = numberFormatter.format(hours);
    minutes = numberFormatter.format(minutes);
    seconds = numberFormatter.format(seconds);

    return (
        <div className="row justify-content-center gx-4 gx-md-5 black-friday-timer">
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`P${days}D`}>
                    {days}
                </time>
                <span className="d-block timer-label">Days</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${hours}H`}>
                    {hours}
                </time>
                <span className="d-block timer-label">Hrs</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${minutes}M`}>
                    {minutes}
                </time>
                <span className="d-block timer-label">Min</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${seconds}S`}>
                    {seconds}
                </time>
                <span className="d-block timer-label">Sec</span>
            </div>
        </div>
    );
};

// Define promotional text for different periods
const BLACK_FRIDAY_OFFER = '$500 off + 50% off + Free Small Area';
const CYBER_WEEK_OFFER = 'best deal ever: 65% OFF Every Body Area.';

const createPromoText = (offerText, message, isCyberWeek = false) => {
    const offer = isCyberWeek ? (
        <>
            Get our <strong>{offerText}</strong>
        </>
    ) : (
        <>
            <strong>{offerText}</strong> with purchase.
        </>
    );

    return (
        <>
            {offer} <br className="d-block d-lg-none" />
            {message}
        </>
    );
};

const blackFridaysSaleText = createPromoText(BLACK_FRIDAY_OFFER, 'Black Friday Sale ends in');
const extendedSaleText = createPromoText(BLACK_FRIDAY_OFFER, 'Black Friday Sale extended for');
const cyberWeekSaleText = createPromoText(CYBER_WEEK_OFFER, 'Cyber Week Sale ends in', true);

function BlackFridayCountdown() {
    const now = new Date();

    // Determine which promotional period we're in
    let text = blackFridaysSaleText;
    let endDate = BLACK_FRIDAY_COUNTDOWN_END_DATE;

    if (now > BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE) {
        text = cyberWeekSaleText;
        endDate = CYBER_WEEK_COUNTDOWN_END_DATE;
    } else if (now > BLACK_FRIDAY_COUNTDOWN_END_DATE) {
        text = extendedSaleText;
        endDate = BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE;
    }

    return (
        <Link to="/specials/" aria-label="View Black Friday special offers and promotions">
            <section
                id="black-friday-countdown"
                className="d-flex align-items-center justify-content-center flex-column text-center py-3"
            >
                <span className="countdown-text pb-2 text-sm">{text}</span>
                <Countdown date={endDate} renderer={Timer} />
            </section>
        </Link>
    );
}

export default BlackFridayCountdown;
